module.exports = __webpack_public_path__ + "img/daheilan.bd053d18.png";